export default __webpack_public_path__ + "static/media/network-message-box-reversed.01863df5.png";